import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "@mui/material/styles";
// URL regex pattern - matches the one used in NewPostCard.tsx for consistency
const URL_REGEX = /https?:\/\/[^\s<>"{}|\\^`[\]]+/gi;
/**
 * Processes text and returns JSX with URLs styled as hyperlinks
 * @param text - The text to process
 * @param onClick - Optional click handler for the entire text container
 * @returns JSX with styled URLs or original text if no URLs found
 */
export const renderTextWithStyledUrls = (text, onClick) => {
    if (!text) {
        return text;
    }
    // Find all URL matches
    const matches = Array.from(text.matchAll(URL_REGEX));
    if (matches.length === 0) {
        // No URLs found, return original text
        return text;
    }
    const segments = [];
    let lastIndex = 0;
    matches.forEach((match, index) => {
        const url = match[0];
        const matchStart = match.index;
        const matchEnd = matchStart + url.length;
        // Add text before the URL
        if (matchStart > lastIndex) {
            const beforeText = text.slice(lastIndex, matchStart);
            segments.push(beforeText);
        }
        // Add the styled URL
        segments.push(_jsx(StyledUrl, { url: url }, `url-${index}`));
        lastIndex = matchEnd;
    });
    // Add remaining text after the last URL
    if (lastIndex < text.length) {
        const afterText = text.slice(lastIndex);
        segments.push(afterText);
    }
    return (_jsx("span", Object.assign({ style: {
            whiteSpace: "pre-line",
            wordBreak: "break-word",
            cursor: onClick ? "pointer" : "auto",
        }, onClick: onClick }, { children: segments })));
};
/**
 * Component for rendering a single styled URL
 */
const StyledUrl = ({ url }) => {
    const theme = useTheme();
    return (_jsx("span", Object.assign({ style: {
            color: theme.palette.violet.main,
            textDecoration: "underline",
            cursor: "default", // Not clickable within text
        } }, { children: url })));
};
/**
 * Extracts the first URL from text (helper function for click handlers)
 * @param text - The text to search
 * @returns The first URL found or null
 */
export const getFirstUrlFromText = (text) => {
    if (!text)
        return null;
    const match = text.match(URL_REGEX);
    return match ? match[0] : null;
};
